<template>
<v-menu :close-on-content-click="cocc" v-model="menu" v-bind:disabled="aktifmi" transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px;">

    <v-text-field @input="mydate()" :tabindex="tabindex" :disabled="aktifmi" :hide-details="detaygizle" slot="activator" append-icon="event" :label="etiket" v-model="dateFormatted" v-on:change="onChange" mask="##.##.####" @blur="date = parseDate(dateFormatted)" :rules="rules" required="">
    </v-text-field>

    <v-date-picker first-day-of-week="1" :locale="dil" v-model="date" @input="dateFormatted = formatDate($event)" no-title scrollable actions>
        <v-spacer></v-spacer>

    </v-date-picker>
</v-menu>
</template>

<script>
export default {

    props: {
        etiket: {
            type: String
        },
        value: {
            type: String
        },
        aktifmi: {
            type: Boolean
        },
        detaygizle: {
            type: Boolean,
            default: true
        },
        defaultvalue: {
            type: String
        },
        dil: {
            type: String,
            default: 'tr'
        },
        tabindex: {
            type: String
        },
        required: {
            type: String,
            default: null
        },
        rules: {
            type: Array,
        }
    },

    data() {
        return {
            cocc: false,
            date: null,
            index1: 0,
            menu: false,
            modal: false,
            dateFormatted: '',
            dictionary: {
                custom: {
                    tarihsec: {
                        required: () => 'Lütfen bir tarih seçiniz'
                    }
                }
            },
        }
    },
    created() {

    },
    beforeMount: beforeMount,
    beforeUpdate: beforeUpdate,
    // mounted: beforeUpdate,

    watch: {
        menu(v) {
            if (v == true) {
                if (typeof this.date === 'undefined') {} else {
                    this.cocc = false
                }
            } else {
                if (typeof this.date === 'undefined') {} else {
                    this.cocc = true
                }
            }
        },

        date(val) {
            if (typeof this.date === 'undefined') {} else {
                this.$emit('input', this.date)
                this.menu = false
            }

        },
        value(v) {

            if (this.index1 == 0) {
                this.index1 = 1
                var typev = typeof (v)
                if (typev != 'undefined') {
                    if (v.length > 0 && v != null && v != '') {
                        var tarih = v
                        var bastarih = tarih.split("T")
                        if (bastarih[0] != '' && bastarih[0] != '0001-01-01' && bastarih[0].length != 0) {
                            this.dateFormatted = toDateformat(bastarih[0])
                            this.date = v
                        }
                    }
                }
            } else {
                if (v != null) {
                    var n = v.search('T')

                    var typev1 = typeof (v)
                    if (typev1 != 'undefined' && n == -1) {
                        this.dateFormatted = toDateformat1(v)
                        this.date = v
                    } else if (n != -1) {
                        var datem = v.split("T")
                        this.dateFormatted = toDateformat(datem[0])
                        this.date = v
                    }
                }
            }
        },
    },
    methods: {
        kontrol(a) {

        },
        mydate() {
            this.index1 = 1
            this.$emit('input', this.date)
        },
        parseDate: parseDate,
        formatDate: formatDate,
        onChange: onChange,
        getDateNow: getDateNow,
        getDateNow1: getDateNow1,
        getDateYear: getDateYear,
        getDateLastYear: getDateLastYear,
        toDateformat: toDateformat,
    }
}

function beforeMount() {

    if (this.defaultvalue == 'ok' && (this.value == '0001-01-01T00:00:00' || this.value == null || this.value ==
            '0001-01-01')) {
        this.date = getDateNow()
        this.dateFormatted = toDateformat1(this.date)
    } else if (this.defaultvalue == 'year' && (this.value == '0001-01-01T00:00:00' || this.value == null || this
            .value ==
            '0001-01-01')) {
        this.date = getDateYear()
        this.dateFormatted = toDateformat1(this.date)

    } else if (this.defaultvalue == 'lastyear' && (this.value == '0001-01-01T00:00:00' || this.value == null || this
            .value ==
            '0001-01-01')) {
        this.date = getDateLastYear()
        this.dateFormatted = toDateformat1(this.date)

    } else if (this.defaultvalue == 'lastyeartoday' && (this.value == '0001-01-01T00:00:00' || this.value == null || this
            .value == '0001-01-01')) {
        this.date = getDateLastYearToday()
        this.dateFormatted = toDateformat1(this.date)

    } else if (this.value != '0001-01-01T00:00:00' && this.value != '0001-01-01' && this.value != null) {
        var n = this.value.search('T')
        if (n == 10) {
            var bastarih = this.value.split("T")
            this.dateFormatted = toDateformat1(bastarih[0])
            this.date = bastarih[0]
        } else {
            this.date = this.value
            this.dateFormatted = toDateformat1(this.date)
        }
    } else {}

}

function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
}

function toDateformat1(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + parts[1] + parts[0]);
}

function parseDate(date) {
    var str = date
    var n = str.search('-')
    var m = str.length

    if (n == 1) {
        const [month, day, year] = date.split('-')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    } else if (m == 8) {
        return this.date
    }
}

function beforeUpdate() {
    if (this.value != null) {
        if (this.defaultvalue == 'ok' && (this.value == '0001-01-01T00:00:00' || this.value == null || this.value ==
                '0001-01-01')) {
            this.date = getDateNow()
            this.dateFormatted = toDateformat1(this.date)
        } else if (this.value != '0001-01-01T00:00:00' && this.value != '0001-01-01' && this.value != null) {
            var n = this.value.search('T')
            if (n == 10) {
                var bastarih = this.value.split("T")
                this.dateFormatted = toDateformat1(bastarih[0])
                this.date = bastarih[0]
            } else {
                this.date = this.value
                this.dateFormatted = toDateformat1(this.date)
            }
        } else {}
    }

}

function formatDate(date) {
    this.cocc = true
    var str = date
    var n = str.search('.')
    if (n == 1) {
        //  return null
    } else {
        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
    }

}

function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {

        var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
        var ay = a[2] + a[3]
        var gun = a[0] + a[1]
        var yil = a[4] + a[5] + a[6] + a[7]

        a = new Date(b)

        if (a instanceof Date && !isNaN(a.valueOf())) {
            //şubatın 29 çekmesin
            if (ay == '02' && yil % 10 != 0 && gun == '29') {

                b = yil + '-' + ay + '-' + '28'
                this.date = b
                this.dateFormatted = '28' + '-' + ay + '-' + yil
                //31 nisan
            } else if (ay == '04' && gun == '31') {

                b = yil + '-' + ay + '-' + '30'
                this.date = b
                this.dateFormatted = '30' + '-' + ay + '-' + yil
                //31 haziran
            } else if (ay == '06' && gun == '31') {

                b = yil + '-' + ay + '-' + '30'
                this.date = b
                this.dateFormatted = '30' + '-' + ay + '-' + yil
                //31 eylül
            } else if (ay == '09' && gun == '31') {

                b = yil + '-' + ay + '-' + '30'
                this.date = b
                this.dateFormatted = '30' + '-' + ay + '-' + yil
                //31 kasım
            } else if (ay == '11' && gun == '31') {

                b = yil + '-' + ay + '-' + '30'
                this.date = b
                this.dateFormatted = '30' + '-' + ay + '-' + yil

            } else {
                this.date = b
            }
        } else {
            this.dateFormatted = null
            this.date = null

        }
    } else {
        this.dateFormatted = null
        this.date = null
    }

}

function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
        dd = '0' + dd
    }

    if (mm < 10) {
        mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
}

function getDateLastYearToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
        dd = '0' + dd
    }

    if (mm < 10) {
        mm = '0' + mm
    }
    today = yyyy - 1 + '-' + mm + '-' + dd
    return today
}

function getDateYear() {
    var today = new Date();

    var yyyy = today.getFullYear();

    today = yyyy + '-' + '01' + '-' + '01'
    return today
}

function getDateLastYear() {
    var today = new Date();

    var yyyy = today.getFullYear();

    today = yyyy - 1 + '-' + '01' + '-' + '01'
    return today
}

function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
        dd = '0' + dd
    }

    if (mm < 10) {
        mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
}
</script>
